import React from "react";

import { Sort } from "./sort";
import { Filter } from "./filter";
import { Props } from "./types";
import styles from "./styles.scss";

function Toolbar(props: Props) {
  return (
    <div className={styles.toolbar}>
      <Sort sort={props.sort} setSort={props.setSort} />
      <Filter filter={props.filter} setFilter={props.setFilter} />
    </div>
  );
}

export { Toolbar };
